import { FaHandshake } from 'react-icons/fa';
import type { AboutSectionData } from '@/sanity/types';

interface AboutCommitmentSectionProps {
  data?: AboutSectionData | undefined;
}

/**
 * R2 - Company commitment section for About Us page
 * R4 - Accepts optional Sanity data, falls back to hardcoded defaults
 */
export function AboutCommitmentSection({ data }: AboutCommitmentSectionProps) {
  const badge = data?.commitmentBadge ?? 'Nuestro Compromiso';
  const title = data?.commitmentTitle ?? 'Calidad y servicio profesional';
  const paragraph1 = data?.commitmentParagraph1 ?? 'Desde nuestros inicios, trabajamos para garantizar productos de calidad, listos para ofrecer <strong class="text-inboca-teal">soluciones rápidas y funcionales</strong> para obras, eventos, proyectos temporales o instalaciones permanentes.';
  const paragraph2 = data?.commitmentParagraph2 ?? 'Nuestro compromiso es brindar un servicio <strong class="text-inboca-orange">profesional, cercano</strong> y orientado a resolver las necesidades de cada cliente.';
  return (
    <section className="relative py-20 sm:py-32 bg-white">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Content */}
          <div className="animate-fade-in-up order-2 lg:order-1">
            <span className="inline-block px-4 py-2 bg-inboca-teal/10 rounded-full text-inboca-teal font-semibold text-sm mb-6">
              {badge}
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              {title}
            </h2>
            <p
              className="text-lg text-gray-700 leading-relaxed mb-6"
              dangerouslySetInnerHTML={{ __html: paragraph1 }}
            />
            <p
              className="text-lg text-gray-700 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: paragraph2 }}
            />
          </div>

          {/* Right: Icon + Visual */}
          <div className="animate-fade-in-up order-1 lg:order-2" style={{ animationDelay: '0.1s' }}>
            <div className="relative">
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-inboca-orange/10 rounded-full blur-2xl" />
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-inboca-teal/10 rounded-full blur-2xl" />
              <div className="relative bg-gradient-to-br from-slate-50 to-inboca-gray rounded-3xl p-12 flex items-center justify-center">
                <div className="h-32 w-32 rounded-2xl bg-gradient-to-br from-inboca-orange/20 to-inboca-teal/20 flex items-center justify-center">
                  <FaHandshake className="h-16 w-16 text-inboca-orange" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
